import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
import users from './users'
/**
* @see \App\Http\Controllers\Api\Teams\SubscriptionStoreController::__invoke
* @see app/Http/Controllers/Api/Teams/SubscriptionStoreController.php:16
* @route '/api/teams/{team}/subscription'
*/
export const subscription = (args: { team: number | { id: number } } | [team: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: subscription.url(args, options),
    method: 'get',
})

subscription.definition = {
    methods: ["get","head"],
    url: '/api/teams/{team}/subscription',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Teams\SubscriptionStoreController::__invoke
* @see app/Http/Controllers/Api/Teams/SubscriptionStoreController.php:16
* @route '/api/teams/{team}/subscription'
*/
subscription.url = (args: { team: number | { id: number } } | [team: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { team: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { team: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            team: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.id
        : args.team,
    }

    return subscription.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Teams\SubscriptionStoreController::__invoke
* @see app/Http/Controllers/Api/Teams/SubscriptionStoreController.php:16
* @route '/api/teams/{team}/subscription'
*/
subscription.get = (args: { team: number | { id: number } } | [team: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: subscription.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Teams\SubscriptionStoreController::__invoke
* @see app/Http/Controllers/Api/Teams/SubscriptionStoreController.php:16
* @route '/api/teams/{team}/subscription'
*/
subscription.head = (args: { team: number | { id: number } } | [team: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: subscription.url(args, options),
    method: 'head',
})

const workspaces = {
    subscription: Object.assign(subscription, subscription),
    users: Object.assign(users, users),
}

export default workspaces